export default __webpack_public_path__ + "static/media/instagram.994c28f1.svg";